module.exports = __webpack_public_path__ + "img/42.bdb22cf3.jpg";